module.exports = __webpack_public_path__ + "static/media/dst-logo-white.734d6e9a.svg";